import React from 'react';

/** Empty-list illustration: a laptop, a phone, and a shield. */
export function DevicesArt() {
  return (
    <svg className="dv-art" viewBox="0 0 420 240" aria-hidden="true">
      <rect className="dv-art__sky" width="420" height="240" rx="28" />
      <circle className="dv-art__sun" cx="348" cy="40" r="16" />
      <circle className="dv-art__cloud" cx="62" cy="50" r="10" />
      <circle className="dv-art__cloud" cx="80" cy="44" r="14" />
      <path
        className="dv-art__hill"
        d="M0 150c52-30 84 10 138-8 44-14 70 18 118-4 30-14 54 8 96-10 18-8 40 4 68-12v124H0z"
      />
      <path className="dv-art__hill2" d="M0 188c64-22 96 14 156-4 48-14 74 16 200-12v68H0z" />
      <rect className="dv-art__screen" x="70" y="72" width="156" height="100" rx="14" />
      <rect className="dv-art__glass" x="84" y="86" width="128" height="70" rx="8" />
      <path className="dv-art__base" d="M58 174h180l-14 16H72z" />
      <rect className="dv-art__phone" x="252" y="64" width="84" height="136" rx="18" />
      <rect className="dv-art__panel" x="264" y="82" width="60" height="96" rx="8" />
      <circle className="dv-art__dot" cx="294" cy="186" r="4" />
      <path
        className="dv-art__shield"
        d="M294 96c-18 8-24 16-24 30 0 20 13 34 24 40 11-6 24-20 24-40 0-14-6-22-24-30z"
      />
      <path
        d="M284 128l7 7 14-16"
        fill="none"
        stroke="#fff"
        strokeWidth="4"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}
